module.exports = __webpack_public_path__ + "static/media/4a.05e63954.jpg";